/**
 * Report row shapes shared by the on-screen preview, PDF, CSV and Word exports (Beta-1 plan
 * P2-23 / P5-06, Tim D09 §2.4.1). Pure.
 *
 *   conditionLogRow(t, org)  → { id, title, typeSubtype, reps, severity, status, owner, priorityDue, refActions }
 *   CONDITION_LOG_COLUMNS    → the header order Tim asked for
 */
import { conditionTypeLabel, conditionSubtypeLabel, conditionStatusLabel, refActionLabel } from './trlConstants.js';

export const CONDITION_LOG_COLUMNS = Object.freeze([
  ['id', 'ID'],
  ['title', 'Title'],
  ['typeSubtype', 'Type / Subtype'],
  ['reps', 'REPS'],
  ['severity', 'Severity (Entrant / L1 / L2)'],
  ['status', 'Status'],
  ['owner', 'Owner'],
  ['priorityDue', 'Priority / Due'],
  ['refActions', 'REF Actions'],
]);

const cap = (s) => (s ? String(s).charAt(0).toUpperCase() + String(s).slice(1) : '');

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v.toDate === 'function') return v.toDate();
  if (typeof v.seconds === 'number') return new Date(v.seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function ownerLabel(t, org) {
  if (t?.ownerName) return t.ownerName;
  const departments = org?.departments || [];
  const teams = org?.teams || [];
  if (t?.ownerNwtId) return teams.find((x) => x.id === t.ownerNwtId)?.name || 'NWT';
  if (t?.ownerDeptId) return departments.find((x) => x.id === t.ownerDeptId)?.name || 'Department';
  return '';
}

export function conditionLogRow(t, org = null) {
  const quads = Array.isArray(t.repsQuadrants) && t.repsQuadrants.length ? t.repsQuadrants : t.repsQuadrant ? [t.repsQuadrant] : [];
  const sub = conditionSubtypeLabel(t);
  const due = toDate(t.dueDate || t.l2?.dueDate);
  const actions = (t.refActions || []).map((a) => `${refActionLabel(a.type)}${a.notes ? `: ${a.notes}` : ''}`);
  const proposed = t.l2?.refActionApproved || t.l1?.refAction || t.refAction;
  if (!actions.length && proposed) actions.push(`${refActionLabel(proposed)} (planned)`);
  return {
    id: t.conditionId || (t.id ? String(t.id).slice(0, 8) : ''),
    title: t.title || '(untitled)',
    typeSubtype: sub ? `${conditionTypeLabel(t.type)} / ${sub}` : conditionTypeLabel(t.type),
    reps: quads.map(cap).join(', '),
    severity: [t.severityITM || '—', t.severityFLS || '—', t.severityDH || '—'].join(' / '),
    status: conditionStatusLabel(t.status),
    owner: ownerLabel(t, org),
    priorityDue: [t.priority || '', due ? due.toISOString().slice(0, 10) : ''].filter(Boolean).join(' · '),
    refActions: actions.join('; '),
  };
}

/** Rows in Tim's column order as plain arrays (CSV / tables). */
export function conditionLogTable(items, org = null) {
  return items.map((t) => {
    const r = conditionLogRow(t, org);
    return CONDITION_LOG_COLUMNS.map(([key]) => r[key]);
  });
}
